import React from "react";
import { useApp } from "@/context/AppContext";
import { ExternalLink, BookOpen } from "lucide-react";
import { externalLinkHandler, externalTarget } from "@/utils/openExternal";

export default function DIY() {
  const { t } = useApp();
  return (
    <section
      id="fainoti"
      data-testid="diy-section"
      className="ht-section border-t"
      style={{ borderColor: "var(--ht-border)" }}
    >
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="ht-card flex flex-col items-start gap-6 p-8 sm:p-12 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <p className="ht-eyebrow flex items-center gap-2">
              <BookOpen size={14} />
              {t.diy.eyebrow}
            </p>
            <h2
              className="mt-3 text-2xl font-bold sm:text-3xl"
              style={{ color: "var(--ht-text)" }}
              data-testid="diy-title"
            >
              {t.diy.title}
            </h2>
            <p className="mt-3 text-sm sm:text-base" style={{ color: "var(--ht-text-muted)" }}>
              {t.diy.subtitle}
            </p>
          </div>
          <a
            href={t.diy.blogUrl}
            target={externalTarget()}
            rel="noopener noreferrer"
            onClick={externalLinkHandler(t.diy.blogUrl)}
            data-testid="diy-blog-cta"
            className="ht-btn-primary inline-flex shrink-0 items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold"
          >
            {t.diy.cta}
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
